module.exports = __webpack_public_path__ + "img/spain-leukaemia-female.580c02b6.png";